module.exports = __webpack_public_path__ + "img/tg_03 (7).ed9ee515.jpg";